/* eslint-disable import/no-anonymous-default-export */
import {
  FETCH_FUTURE_BOT_STATUS_ERROR,
  FETCH_FUTURE_BOT_STATUS,
} from '../types';

const initialState = {
  futureBotStatusData: [],
  success: false,
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FUTURE_BOT_STATUS:
      return {
        ...state,
        futureBotStatusData: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_BOT_STATUS_ERROR:
      return {
        ...state,
        futureBotStatusData: [],
        success: false,
        loading: false,
      };

    default:
      return state;
  }
}
